import CryptoJS from "crypto-js";
import { app_encr_decript_sec_key } from "../MasterData/config";

export const decrypt = (encrypted) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(
      encrypted,
      app_encr_decript_sec_key
    ).toString(CryptoJS.enc.Utf8);
    return decrypted;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export let encrypt = (text) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(
      text,
      app_encr_decript_sec_key
    ).toString();
    return encrypted;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

/**
 * Decode JWT token without verification
 * @param {string} token - The JWT token to decode
 * @returns {object|null} - The decoded payload or null if invalid
 */
export const decodeJWT = (token) => {
  try {
    if (!token) {
      console.error("No token provided");
      return null;
    }

    // Split the token into parts
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error("Invalid JWT format");
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    
    // Base64 decode (handle URL-safe base64)
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("JWT decode error:", error);
    return null;
  }
};

/**
 * Decode and return the full payload from the stored JWT auth token.
 * Use this as the single source of truth for any token claim
 * (e.g. clientId, menuList, roles, userId, …).
 *
 * @returns {object|null} - The decoded JWT payload, or null if unavailable / invalid
 */
export const getAuthTokenPayload = () => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) return null;

    return decodeJWT(token);
  } catch (error) {
    console.error("Error decoding auth token payload:", error);
    return null;
  }
};

/**
 * This app has no login screen of its own when reached from the auth app -
 * the auth app appends authToken/isAuthenticated/loginTime as URL params
 * instead. Read them into localStorage and strip them from the URL.
 *
 * Must run before the app renders anything (see src/index.js) - components
 * like Header read the token synchronously during render, and a localStorage
 * write alone doesn't trigger a re-render, so consuming it later (e.g. in a
 * useEffect) leaves those components stuck with the stale token until
 * something else forces a re-render (like a manual page refresh).
 */
export const consumeAuthFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const authToken = params.get("authToken");
  if (!authToken) return;

  localStorage.setItem("authToken", authToken);
  localStorage.setItem("isAuthenticated", params.get("isAuthenticated") || "true");
  localStorage.setItem("loginTime", params.get("loginTime") || Date.now().toString());

  params.delete("authToken");
  params.delete("isAuthenticated");
  params.delete("loginTime");
  const remaining = params.toString();
  const cleanUrl =
    window.location.pathname + (remaining ? `?${remaining}` : "") + window.location.hash;
  window.history.replaceState({}, "", cleanUrl);
};
